export async function leaveProjectWithConfirmation({ openModal, project, userEmail, }) {
    const { openLeaveSpaceModal } = await import('#pplx/frontend/apps/ask/spaces-redesign/create-space-modal/hooks/useLeaveSpaceModal.js');
    openLeaveSpaceModal(openModal, project, userEmail);
}
export async function deleteProjectWithConfirmation({ openModal, project, }) {
    const { openDeleteSpaceModal } = await import('#pplx/frontend/apps/ask/spaces-redesign/hooks/useDeleteSpaceModal.js');
    openDeleteSpaceModal(openModal, project);
}
//# sourceMappingURL=projectModalActions.js.map